import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Unit } from '../units';

const getLocationUnits = async (
  locationId: string,
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ units: Unit[]; totalPages: number }> => {
  const response = await fetch(
    `/api/locations/${locationId}/units?q=${searchQuery || ''}&page=${page || 1}&limit=${limit || 10}`,
  );

  if (!response.ok) {
    throw new Error('Failed to fetch location units');
  }

  const data = await response.json();

  return data;
};

export const LOCATION_UNITS_QUERY_KEY = 'locationUnits';

export const useLocationUnits = ({
  locationId,
  searchQuery,
  page = 1,
  limit = 10,
}: {
  locationId: string;
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [LOCATION_UNITS_QUERY_KEY, locationId, searchQuery, page, limit],
    queryFn: () => getLocationUnits(locationId, searchQuery, page, limit),
    placeholderData: keepPreviousData,
    enabled: !!locationId,
  });
